import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-x-1 pr-16" }
const _hoisted_2 = { class: "absolute inset-y-0 right-3 flex items-center" }
const _hoisted_3 = {
  class: "w-400px select bg-white rounded-md overflow-x-show overflow-y-auto font-montserrat flex flex-col gap-y-4 pt-3",
  style: { maxHeight: '70vh' }
}
const _hoisted_4 = { class: "border-b border-gray-lp-400 px-4 pb-4" }
const _hoisted_5 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_6 = { class: "border-b border-gray-lp-400 px-4 pb-4" }
const _hoisted_7 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_8 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px my-2" }
const _hoisted_9 = { class: "border-b border-gray-lp-400 px-4 pb-4" }
const _hoisted_10 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_11 = { class: "border-b border-gray-lp-400 px-4 pb-4 flex flex-col gap-y-3" }
const _hoisted_12 = { class: "font-semibold flex gap-2 items-end" }
const _hoisted_13 = { class: "flex gap-2 items-end" }
const _hoisted_14 = { class: "font-semibold flex gap-2 items-end" }
const _hoisted_15 = { class: "flex gap-2 items-end" }
const _hoisted_16 = { class: "border-b border-gray-lp-400 px-4 pb-4" }
const _hoisted_17 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_18 = { class: "w-1/2 pl-2.5 py-2 border-r border-gray-lp-400" }
const _hoisted_19 = { class: "w-1/2 pl-2.5 py-2" }
const _hoisted_20 = { class: "relative border-b border-gray-lp-400 px-4 pb-4" }
const _hoisted_21 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_22 = { class: "w-full py-4 px-3" }
const _hoisted_23 = { class: "flex flex-row mb-3" }
const _hoisted_24 = { class: "ml-3" }
const _hoisted_25 = {
  key: 0,
  class: "pl-8 overflow-y-scroll"
}
const _hoisted_26 = { class: "ml-3" }
const _hoisted_27 = {
  key: 0,
  class: "relative border-b border-gray-lp-400 px-4 pb-4"
}
const _hoisted_28 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_29 = { class: "p-field-checkbox" }
const _hoisted_30 = /*#__PURE__*/_createVNode("label", {
  class: "ml-2.5 text-sm",
  for: "binary-cod"
}, " Cash On Delivery (COD) ", -1)
const _hoisted_31 = {
  key: 0,
  class: "p-field-checkbox mt-1.5"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("label", {
  class: "ml-2.5 text-sm",
  for: "binary-pad"
}, " Payment At Delivery ", -1)
const _hoisted_33 = { class: "p-field-checkbox mt-1.5" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", {
  class: "ml-2.5 text-sm",
  for: "binary-dfod"
}, " Delivery Fee On Delivery (DFOD) ", -1)
const _hoisted_35 = { class: "relative px-4" }
const _hoisted_36 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_37 = { class: "z-50 sticky bottom-0 border-t border-gray-lp-400 bg-white flex gap-x-2 items-center py-2 px-4" }
const _hoisted_38 = { class: "w-full" }
const _hoisted_39 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_TimeRangePickerV3 = _resolveComponent("TimeRangePickerV3")!
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock("div", {
    class: "advanced-filter inline-block relative text-sm",
    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onOpenFilter && _ctx.onOpenFilter(...args)))
  }, [
    _createVNode("div", {
      class: ["border rounded-md leading-tight px-3 font-normal w-max relative cursor-pointer py-2.5", 
        `${
          _ctx.totalFilter
            ? 'bg-red-lp-1100 border-pink-lp-300 text-red-lp-100'
            : 'bg-white border-gray-lp-400 text-gray-lp-300'
        }`
      ]
    }, [
      _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("bookingShipment.filter")) + " " + _toDisplayString(_ctx.totalFilter ? `(${_ctx.totalFilter})` : ""), 1),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Icons, {
          name: _ctx.openFilter ? 'chevron-up' : 'chevron-down',
          class: ["w-4", {
            'text-red-lp-100': _ctx.totalFilter
          }]
        }, null, 8, ["name", "class"])
      ])
    ], 2),
    _createVNode(_component_OverlayPanel, {
      ref: "opAdvancedFilterBooking",
      id: "advanced-filter-booking"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("bookingShipment.filterLabels.bookingPeriod")), 1),
            _createVNode(_component_TimeRangePickerV3, {
              isCloseDateAfterSelect: "",
              default: _ctx.$t('30 hari terakhir'),
              placeholder: _ctx.$t('bookingShipment.filterLabels.dateRange'),
              highlightOnSelected: "",
              customCalendar: "",
              advanceStyle: {
              width: '550px',
              fontSize: 'text-sm',
              fontWeight: 'font-medium'
            },
              customTotalMaxDate: 30,
              resetLimitOnSetOption: "",
              isDateAlignCenter: "",
              maxDate: new Date(),
              isSetMaxDate: "",
              startDate: _ctx.filterData.periodeStart,
              endDate: _ctx.filterData.periodeEnd,
              customDefaultValue: "",
              labelCustom: _ctx.$t('bookingShipment.filterLabels.dateRangeLabel'),
              showOptions: 
              `${_ctx.$t('custom')}, ${_ctx.$t('hari ini')}, ${_ctx.$t(
                '7 hari terakhir'
              )}, ${_ctx.$t('30 hari terakhir')}`
            ,
              isConvertName: "",
              isMounted: false,
              onSelect: _ctx.setPeriode
            }, null, 8, ["default", "placeholder", "maxDate", "startDate", "endDate", "labelCustom", "showOptions", "onSelect"])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("bookingShipment.filterLabels.originDistrictCity")), 1),
            _createVNode(_component_SelectSearchV2, {
              onChevron: _cache[1] || (_cache[1] = (e) => (_ctx.isChevron = e)),
              onFilter: _cache[2] || (_cache[2] = (e) => _ctx.fetchOriginDestination(e, 'origin')),
              onFocus: _cache[3] || (_cache[3] = 
              () => {
                _ctx.fetchOriginDestination(_ctx.formOrigin, 'origin');
              }
            ),
              isLoading: _ctx.loadingOriginDestination,
              options: _ctx.originList,
              keyName: "name",
              keyValue: "code",
              placeholder: 
              _ctx.$t('bookingShipment.placeholderSelect.selectDistrictOriginCity')
            ,
              modelValue: _ctx.form.origin,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.origin = $event)),
                _ctx.onChangeOrigin
              ],
              class: "mb-2",
              key: _ctx.resetSelectSearch
            }, null, 8, ["isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"]),
            _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("bookingShipment.filterLabels.destinationDistrictCity")), 1),
            _createVNode(_component_SelectSearchV2, {
              onChevron: _cache[5] || (_cache[5] = (e) => (_ctx.isChevron = e)),
              onFilter: _cache[6] || (_cache[6] = (e) => _ctx.fetchOriginDestination(e, 'destination')),
              onFocus: _cache[7] || (_cache[7] = 
              () => {
                _ctx.fetchOriginDestination(_ctx.formDestination, 'destination');
              }
            ),
              isLoading: _ctx.loadingOriginDestination,
              options: _ctx.destinationList,
              keyName: "name",
              keyValue: "code",
              placeholder: 
              _ctx.$t(
                'bookingShipment.placeholderSelect.SelectDistrictDestinationCity'
              )
            ,
              modelValue: _ctx.form.destination,
              "onUpdate:modelValue": [
                _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.destination = $event)),
                _ctx.onChangeDestination
              ],
              key: _ctx.resetSelectSearch
            }, null, 8, ["isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("bookingShipment.filterLabels.bookedFor")), 1),
            _createVNode(_component_SelectSearchV2, {
              onChevron: _cache[9] || (_cache[9] = (e) => (_ctx.isChevron = e)),
              onFilter: _ctx.fetchClientPartner,
              onFocus: _cache[10] || (_cache[10] = 
              () => {
                _ctx.fetchClientPartner(_ctx.formClient);
              }
            ),
              isLoading: _ctx.loadingClientPartner,
              options: _ctx.clientPartnerData,
              keyName: "name",
              keyValue: "code",
              placeholder: 
              _ctx.$t('bookingShipment.filterLabels.selectClientPartner')
            ,
              modelValue: _ctx.form.client,
              "onUpdate:modelValue": [
                _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.client = $event)),
                _ctx.onChangeClient
              ],
              key: _ctx.resetSelectSearch
            }, null, 8, ["onFilter", "isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bookingShipment.filterLabels.senderPhone'),
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_13, [
                    _createVNode(_component_SelectPhoneCountry, {
                      column: "Penerima",
                      prefixWidth: "w-2/5",
                      phone: _ctx.phoneSender,
                      code: _ctx.phoneCodeSender,
                      flag: _ctx.phoneFlagSender,
                      onSetPhone: _ctx.setPhoneSender,
                      onSetPhoneCode: _ctx.setPhoneCodeSender,
                      onSetPhoneFlag: _ctx.setPhoneFlagSender
                    }, null, 8, ["phone", "code", "flag", "onSetPhone", "onSetPhoneCode", "onSetPhoneFlag"]),
                    _createVNode(_component_lp_button, {
                      disabled: !_ctx.phoneSender,
                      title: _ctx.$t('Cari'),
                      textColor: "white",
                      onClick: _ctx.onSearchPhoneSender
                    }, null, 8, ["disabled", "title", "onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bookingShipment.filterLabels.receiverPhone'),
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_15, [
                    _createVNode(_component_SelectPhoneCountry, {
                      column: "Penerima",
                      prefixWidth: "w-2/5",
                      phone: _ctx.phoneReceiver,
                      code: _ctx.phoneCodeReceiver,
                      flag: _ctx.phoneFlagReceiver,
                      onSetPhone: _ctx.setPhoneReceiver,
                      onSetPhoneCode: _ctx.setPhoneCodeReceiver,
                      onSetPhoneFlag: _ctx.setPhoneFlagReceiver
                    }, null, 8, ["phone", "code", "flag", "onSetPhone", "onSetPhoneCode", "onSetPhoneFlag"]),
                    _createVNode(_component_lp_button, {
                      disabled: !_ctx.phoneReceiver,
                      title: _ctx.$t('Cari'),
                      textColor: "white",
                      onClick: _ctx.onSearchPhoneReceiver
                    }, null, 8, ["disabled", "title", "onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("bookingShipment.filterLabels.shipmentType")), 1),
            _createVNode(_component_CustomDropdown, {
              placeholder: _ctx.$t('bookingShipment.filterLabels.selectShipmentType'),
              value: 
              _ctx.filterData.product.length
                ? `${_ctx.filterData.product.length} ${_ctx.$t(
                    'bookingShipment.list.filter.serviceType'
                  )}`
                : ''
            
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_18, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productOptions, (product, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "p-field-checkbox mt-1"
                    }, [
                      (index < 5)
                        ? (_openBlock(), _createBlock(_component_Checkbox, {
                            key: 0,
                            name: "product",
                            id: String(index),
                            value: product.code,
                            modelValue: _ctx.filterData.product,
                            "onUpdate:modelValue": ($event: any) => (_ctx.filterData.product = $event),
                            onClick: _ctx.onChange
                          }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "onClick"]))
                        : _createCommentVNode("", true),
                      (index < 5)
                        ? (_openBlock(), _createBlock("label", {
                            key: 1,
                            for: String(index),
                            class: "ml-2.5"
                          }, _toDisplayString(product.name === "INTERPACKMAXI"
                      ? "INTERPACK MAXI"
                      : product.name), 9, ["for"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _createVNode("div", _hoisted_19, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productOptions, (product, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "p-field-checkbox mt-1.5"
                    }, [
                      (index > 4)
                        ? (_openBlock(), _createBlock(_component_Checkbox, {
                            key: 0,
                            name: "product",
                            id: String(index),
                            value: product.code,
                            modelValue: _ctx.filterData.product,
                            "onUpdate:modelValue": ($event: any) => (_ctx.filterData.product = $event),
                            onClick: _ctx.onChange
                          }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "onClick"]))
                        : _createCommentVNode("", true),
                      (index > 4)
                        ? (_openBlock(), _createBlock("label", {
                            key: 1,
                            for: String(index),
                            class: "ml-2.5"
                          }, _toDisplayString(product.name), 9, ["for"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["placeholder", "value"])
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("bookingShipment.filterLabels.status")), 1),
            _createVNode(_component_CustomDropdown, {
              placeholder: _ctx.$t('bookingShipment.filterLabels.selectStatus'),
              value: 
              `${
                _ctx.filterData.nestedStatus.length
                  ? `${_ctx.filterData.nestedStatus.length} Status`
                  : ''
              }`
            ,
              isExpand: _ctx.statusOpened,
              "onUpdate:isExpand": _cache[12] || (_cache[12] = ($event: any) => (_ctx.statusOpened = $event)),
              customClassExpand: "relative block",
              customClassHeight: ""
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_22, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nestedStatusOptions, (status, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index.toString()
                    }, [
                      _createVNode("div", _hoisted_23, [
                        _createVNode(_component_Checkbox, {
                          binary: "",
                          modelValue: _ctx.isParentSelected(index),
                          onClick: () => _ctx.selectParentStatus(index)
                        }, null, 8, ["modelValue", "onClick"]),
                        _createVNode("button", {
                          class: "w-full flex flex-row justify-between items-center",
                          onClick: 
                      () => {
                        _ctx.expandedStatus[index] = !_ctx.expandedStatus[index];
                      }
                    
                        }, [
                          _createVNode("div", _hoisted_24, _toDisplayString(status.name), 1),
                          _createVNode("img", {
                            src: 
                        require(`@/app/ui/assets/svg/chevron-${
                          _ctx.expandedStatus[index] ? 'up' : 'down'
                        }.svg`)
                      ,
                            alt: "chevron-up",
                            class: "w-4"
                          }, null, 8, ["src"])
                        ], 8, ["onClick"])
                      ]),
                      (_ctx.expandedStatus[index])
                        ? (_openBlock(), _createBlock("div", _hoisted_25, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(status.children, (child) => {
                              return (_openBlock(), _createBlock("button", {
                                key: child.name,
                                class: "flex flex-row items-center mb-3",
                                onClick: () => _ctx.selectChildNestedStatus(child.value)
                              }, [
                                _createVNode(_component_Checkbox, {
                                  binary: "",
                                  modelValue: 
                        _ctx.filterData.nestedStatus.includes(child.value)
                      
                                }, null, 8, ["modelValue"]),
                                _createVNode("div", _hoisted_26, _toDisplayString(child.name), 1)
                              ], 8, ["onClick"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["placeholder", "value", "isExpand"])
          ]),
          (!_ctx.accountIsForeign)
            ? (_openBlock(), _createBlock("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("bookingShipment.filterLabels.deliveryServiceType")), 1),
                _createVNode("div", _hoisted_29, [
                  _createVNode(_component_Checkbox, {
                    id: "binary-cod",
                    modelValue: _ctx.filterData.COD,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.filterData.COD = $event)),
                    binary: "",
                    onClick: _ctx.onChange
                  }, null, 8, ["modelValue", "onClick"]),
                  _hoisted_30
                ]),
                (_ctx.isEnableCodBooking)
                  ? (_openBlock(), _createBlock("div", _hoisted_31, [
                      _createVNode(_component_Checkbox, {
                        id: "binary-pad",
                        modelValue: _ctx.filterData.PAD,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.filterData.PAD = $event)),
                        binary: "",
                        onClick: _ctx.onChange
                      }, null, 8, ["modelValue", "onClick"]),
                      _hoisted_32
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_33, [
                  _createVNode(_component_Checkbox, {
                    id: "binary-dfod",
                    modelValue: _ctx.filterData.DFOD,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.filterData.DFOD = $event)),
                    binary: "",
                    onClick: _ctx.onChange
                  }, null, 8, ["modelValue", "onClick"]),
                  _hoisted_34
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_35, [
            _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("bookingShipment.filterLabels.shippingProtection")), 1),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.asuransiOptions, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "p-field-checkbox mt-1.5"
              }, [
                _createVNode(_component_Checkbox, {
                  id: `asuransi${index}`,
                  name: "asuransi",
                  value: item.code,
                  modelValue: _ctx.filterData.asuransi,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.filterData.asuransi = $event)),
                  onClick: _ctx.onChange
                }, null, 8, ["id", "value", "modelValue", "onClick"]),
                _createVNode("label", {
                  for: `asuransi${index}`,
                  class: "ml-2.5 text-sm"
                }, _toDisplayString(_ctx.$t(item.name)), 9, ["for"])
              ]))
            }), 128))
          ]),
          _createVNode("div", _hoisted_37, [
            _createVNode("div", _hoisted_38, [
              _createVNode(_component_LpButton, {
                color: "white",
                textColor: "red-lp-100",
                title: "Reset",
                flat: "",
                onClick: _ctx.resetToDefaultFilter,
                isWidthFull: ""
              }, null, 8, ["onClick"])
            ]),
            _createVNode("div", _hoisted_39, [
              _createVNode(_component_LpButton, {
                color: "red-lp-100",
                textColor: "white",
                title: _ctx.$t('bookingShipment.filterLabels.apply'),
                onClick: _ctx.applyFilter,
                isWidthFull: ""
              }, null, 8, ["title", "onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}